import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PropertySaleHistories from '../pages/PropertySaleHistories';
import NotificationPropertyList from '../pages/NotificationProperty/List';
import NotificationPropertyForm from '../pages/NotificationProperty/Form';
import SpecialNotificationPropertyForm from '../pages/NotificationProperty/SpecialForm';
import SimulationPage from '../pages/SimulationPage';
import LoginPage from '../pages/Login';
import ProtectedRoute from '../components/common/ProtectedRoute';

export const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route path="/" element={<ProtectedRoute><Navigate to="/property-sale-histories" replace /></ProtectedRoute>} />

      <Route path="/property-sale-histories" element={<ProtectedRoute><PropertySaleHistories /></ProtectedRoute>} />
      <Route path="/notification-properties" element={<ProtectedRoute><NotificationPropertyList /></ProtectedRoute>} />
      <Route path="/notification-properties/new" element={<ProtectedRoute><NotificationPropertyForm /></ProtectedRoute>} />
      <Route path="/notification-properties/edit/:id" element={<ProtectedRoute><NotificationPropertyForm /></ProtectedRoute>} />
      <Route path="/notification-properties/special/new" element={<ProtectedRoute><SpecialNotificationPropertyForm /></ProtectedRoute>} />
      <Route path="/notification-properties/special/edit/:id" element={<ProtectedRoute><SpecialNotificationPropertyForm /></ProtectedRoute>} />
      <Route path="/simulation" element={<ProtectedRoute><SimulationPage /></ProtectedRoute>} />

      <Route path="*" element={
        <div style={{ textAlign: 'center', padding: '100px 0', color: '#999' }}>
          <h2>404 - ページが見つかりません</h2>
          <p>指定されたURLは存在しません</p>
        </div>
      } />
    </Routes>
  );
};
